enum JoinToSpeakRole {
  Host,
  Speaker,
  Audience,
}

export { JoinToSpeakRole }
